const otpFormEn = {
  'otpForm': {
    'codeLabel': 'Code from the SMS',
    'sendNewSms': 'Send the code again',
    'description': 'Enter the code from the SMS sent to your number {{phone}}',
    'resendCodeAfter': 'Send the code again after',
    'confirm': 'Confirm',
    'errors': {
      'sms_auth_code_expired': 'Code has been expired. Request a new one',
      'sms_auth_code_invalid': 'Incorrectly entered code. Please check it and try again',
      'sms_auth_code_many_attempts': 'Code is invalid. Request a new one',
      'sms_auth_sms_not_sent': 'SMS could not be sent due to an unexpected error',
    },
  },
};

export default otpFormEn;
